import { DateTimePicker } from '../../../DateTime'
import { Control } from '../Control'

function ControlDateTime({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: nextValue })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <DateTimePicker
        borderless
        disabled={value.omitted}
        value={value.value ?? null}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlDateTime
